import React from 'react';
import './ColumnTemplate.scss';
import ActionColumn from './ColumnElements/ActionColumn';
import ButtonColumn from './ColumnElements/ButtonColumn';
import ReadonlyColumn from './ColumnElements/ReadonlyColumn';

export interface ColumnTemplate {
    id: ColumnTemplateType;
    label: string;
    type: 'readonly' | 'action' | 'button';
    component: React.ComponentType<any>;
    action?: (data: any, row: any) => void;
}

export interface ColumnConfig {
    dataField: string;
    text: string;
    readonly: boolean;
    component?: React.ComponentType<any>;
    action?: (data: any, row: any) => void;
    actionParameter?: (rowData: any) => any;
    formatter?: (cell: any, row: any) => React.ReactNode;
    headerStyle?: React.CSSProperties;
    id: string;
}

export type TableDataConfig = Record<
    number,
    {
        columns?: ColumnConfig[];
        data?: any[];
    }
>;

export interface ColumnParams {
    row: any;
    value?: any;
    readonly: boolean;
    action?: (data: any, row: any) => void;
    actionParameter?: (rowData: any) => any;
}

export enum ColumnTemplateType {
    Readonly,
    Action,
    Button,
}

export const columnTemplates: ColumnTemplate[] = [
    {
        id: ColumnTemplateType.Readonly,
        label: 'Readonly Column',
        type: 'readonly',
        component: ReadonlyColumn,
    },
    {
        id: ColumnTemplateType.Action,
        label: 'Action Column',
        type: 'action',
        component: ActionColumn,
        action: (data) => {
            console.log('Action triggered:', data);
        },
    },
    {
        id: ColumnTemplateType.Button,
        label: 'Button Column',
        type: 'button',
        component: ButtonColumn,
        action: (data) => {
            console.log('Button clicked:', data);
        },
    },
];
